import { render, staticRenderFns } from "./HomeFaq.vue?vue&type=template&id=145ff1f9&scoped=true"
import script from "./HomeFaq.js?vue&type=script&lang=js&external"
export * from "./HomeFaq.js?vue&type=script&lang=js&external"
import style0 from "./HomeFaq.scss?vue&type=style&index=0&id=145ff1f9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145ff1f9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Title/Title.vue').default,HotAccordionItem: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/AccordionItem/AccordionItem.vue').default,HotAccordion: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Accordion/Accordion.vue').default,HotContainer: require('/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Templates/Container/Container.vue').default})
